<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">Type de document</h1>
    </div>
    <DocumentTypeForm editMode />
  </div>
</template>

<script>
  import DocumentTypeForm from './DocumentTypeForm.vue';

  export default {
    name: 'DocumentTypeEdit',
    components: { DocumentTypeForm },
  };
</script>
